import { render } from "./Punalur.vue?vue&type=template&id=fa2b24d4"
import script from "./Punalur.vue?vue&type=script&lang=ts"
export * from "./Punalur.vue?vue&type=script&lang=ts"
script.render = render

export default script